import React, { useEffect, useState } from "react";
import axios from "axios";

const SystemActivity = () => {
  const [logs, setLogs] = useState([]);
  let token = JSON.parse(localStorage.getItem('key'));

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const response = await axios.get("http://localhost:8082/api/system/logs",{
                headers: {
                  "authorization": `bearer ${token.value}`, // Example header for auth
                  'Content-Type': 'application/json',             // Example custom header
                }
        });
        console.log(response.data);return false;
        setLogs(response.data);
      } catch (error) {
        console.error("Error fetching logs:", error);
      }
    };

    const interval = setInterval(fetchLogs, 5000); // Fetch logs every 5 seconds
    fetchLogs(); // Initial fetch

    return () => clearInterval(interval); // Cleanup interval
  }, []);

  return (
    <div>
      <h1>System Activity Logs</h1>
      <ul>
        {logs.map((log, index) => (
          <li key={index}>
            <strong>{log.timestamp}:</strong> {log.type} -{" "}
            {JSON.stringify(log.details)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SystemActivity;
